/**
 * What went wrong, in words a person can act on.
 *
 * Supabase rejects a query with a plain object, not an Error, so the usual
 * `err instanceof Error ? err.message : fallback` throws away the only useful part and
 * shows a generic sentence instead. That cost real debugging time on the AP list, where
 * a 300 from an ambiguous embed reached the screen as 'Could not load'.
 *
 * PostgREST also sends a `hint`, which is often the actual fix, so it is kept.
 */
export function errText(err: unknown, fallback: string): string {
  if (err instanceof Error) return err.message
  if (err && typeof err === 'object') {
    const e = err as { message?: unknown; hint?: unknown; details?: unknown }
    const parts: string[] = []
    if (typeof e.message === 'string' && e.message) parts.push(e.message)
    if (typeof e.details === 'string' && e.details && e.details !== e.message) parts.push(e.details)
    if (typeof e.hint === 'string' && e.hint) parts.push(e.hint)
    if (parts.length) return parts.join(' ')
  }
  return fallback
}
